import {useTranslation} from 'react-i18next'
import {StyledImagesCounter} from './style'

export const ImagesCounter = ({count}: {count: number}) => {
    const {t} = useTranslation()

    return <StyledImagesCounter>{t('commons:x_images_selected', {count})}</StyledImagesCounter>
}
